import gql from 'graphql-tag';

export const leadListGql = gql`
  query (
    $inst_id: String!
    $account_id: String!
    $filters: String
    $sort: String!
    $search: String!
    $page: Int
    $size: Int
    $myListsOnly: Boolean!
  ) {
    paginatedList(
      instId: $inst_id
      accountId: $account_id
      filters: $filters
      sort: $sort
      search: $search
      page: $page
      size: $size
      myListsOnly: $myListsOnly
    ) {
      list {
        userKeyConsolidated: id
        createdAt
        lastModified: updatedAt
        deletedAt
        name
        instId
        accountId
        system
        privacy: shared
        filters
        orderBy
        attributes
        createdBy: createUser
        updateUser
        listType
        leads: count
      }
      page
      totalPages
      totalRecords
      recordsPerPage
      prevPage
      nextPage
    }
  }
`;

export const updateListGql = gql`
  mutation (
    $inst_id: String!
    $account_id: String!
    $id: String!
    $name: String!
    $filters: FilterExpressionInput
    $over_write: Boolean
    $audiencesSearch: String
  ) {
    listUpdate(
      instId: $inst_id
      accountId: $account_id
      id: $id
      name: $name
      filters: $filters
      over_write: $over_write
      audiencesSearch: $audiencesSearch
    ) {
      data {
        count
        updatedAt
        id
        accountId
        system
        shared
        name
        deletedAt
        orderBy
        attributes
      }
      rows_modified
      message
      code
    }
  }
`;

export const appendUsersToListGql = gql`
  mutation (
    $inst_id: String!
    $account_id: String!
    $id: String!
    $over_write: Boolean
    $profiles: [ListAudienceAppendInput!]!
  ) {
    listAudienceAppendIds(
      accountId: $account_id
      instId: $inst_id
      id: $id
      over_write: $over_write
      profiles: $profiles
    ) {
      message
      data {
        count
        listType
        name
      }
      rows_modified
    }
  }
`;
